import { render, staticRenderFns } from "./OrderNavBar.vue?vue&type=template&id=03a9c048&"
import script from "./OrderNavBar.vue?vue&type=script&lang=ts&"
export * from "./OrderNavBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a9c048')) {
      api.createRecord('03a9c048', component.options)
    } else {
      api.reload('03a9c048', component.options)
    }
    module.hot.accept("./OrderNavBar.vue?vue&type=template&id=03a9c048&", function () {
      api.rerender('03a9c048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/navigation/OrderNavBar.vue"
export default component.exports